import { getApis } from 'library/Apis';
import api from 'services/api';
import SnackbarUtils from "utils/SnackbarUtils";

const getEndpoint = () => {
  return getApis().apis.bff + 'v1/escola/cadastro-pendente';
};

export const hasCadastroPendente = async () => {
  try {
    const response = await api.get(getEndpoint());
    return response.data.cadstroPendente;
  } catch (error) {
    SnackbarUtils.error(
      `Erro ao verificar cadastro pendente:', ${error}`
    );
    return false;
  }
};
